import React from "react";

export default function Login() {
  return <h1>hello from login page</h1>;
}
